function WhyWithdraw() {
    return (
        <section id="WhyWithdraw" className="bg-white py-10 px-6">
            <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-2xl font-bold text-gray-800">🤔 Por que sacar o limite do cartão?</h2>
                <p className="mt-4 text-gray-700">
                    O saque do limite do cartão consignado BMG é uma opção prática para emergências, pagamento de contas ou quando
                    você precisa de dinheiro rápido. Com taxas menores e desconto automático do valor mínimo, pode ser uma solução mais barata que outros empréstimos.
                </p>
            </div>
        </section>
    )
}

export default WhyWithdraw